export default __webpack_public_path__ + "static/media/empty_bg.5427b0fc.svg";